import ConversationItem from 'models/conversation_item';
import ConversationItemType from 'models/conversation_item_type';
import VoiceAICall from 'models/voiceai_call';
import Communicator from 'models/communicator';

export function createVirtualVoiceAICallItem(item) {
  return ConversationItem.create({
    id: item.content.automationSessionId,
    timestamp: item.timestamp,
    content: VoiceAICall.create({
      automationSessionId: item.content.automationSessionId,
      isTranscriptCollapsed: true,
      customerNumber: item.content.customerNumber,
      companyNumber: item.content.companyNumber,
    }),
    customerId: item.customerId,
    conversationId: item.conversationId,
    initiator: {
      id: item.customerId,
      type: Communicator.CUSTOMER,
    },
  });
}

export function isVoiceAICallItem(item) {
  switch (item.contentType()) {
    case ConversationItemType.VOICE_AI_MESSAGE:
    case ConversationItemType.VOICE_AI_RECORDING:
    case ConversationItemType.VOICE_AI_SESSION_ENDED:
      return true;
  }

  return false;
}
